import AppConstants from '../constants/AppConstants';

export const initialState = {
    list: [],
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.POSTBACK_PARAMETERS_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.POSTBACK_PARAMETERS_LOAD_SUCCESS:
            return {
                ...state,
                list: action.items,
                loading: false
            };

        default:
            return state;
    }
};
